var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1243_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7548 40.0312C31.8091 40.0312 40.7704 31.0699 40.7704 20.0156C40.7704 8.96128 31.8091 0 20.7548 0C9.70054 0 0.739258 8.96128 0.739258 20.0156C0.739258 31.0699 9.70054 40.0312 20.7548 40.0312Z",
    fill: "url(#paint0_linear_1243_223)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78089 19.7974C15.611 17.2408 19.5081 15.5885 21.4722 14.7779C27.0217 12.4708 28.1753 12.0655 28.9235 12.0343C29.0794 12.0343 29.4535 12.0655 29.703 12.2525C29.89 12.4084 29.9524 12.6267 29.9835 12.7825C30.0147 12.9384 30.0459 13.2814 30.0147 13.562C29.703 16.7108 28.4247 24.4115 27.7388 27.9345C27.4582 29.431 26.897 29.9299 26.367 29.9922C25.2135 30.0857 24.3093 29.2128 23.187 28.4957C21.4411 27.3422 20.4434 26.6251 18.7287 25.5027C16.7645 24.1933 18.0428 23.4762 19.1651 22.3227C19.4457 22.0109 24.5899 17.3656 24.6835 16.9291C24.6835 16.8667 24.7146 16.6797 24.5899 16.5861C24.4652 16.4926 24.3093 16.5238 24.1846 16.555C23.9976 16.5861 21.1916 18.4567 15.7357 22.1356C14.9251 22.6968 14.208 22.9462 13.5533 22.9462C12.8362 22.9462 11.4644 22.5409 10.4356 22.198C9.18853 21.7927 8.19087 21.5744 8.2844 20.8885C8.34675 20.5456 8.84559 20.1715 9.78089 19.7974Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1243_223",
    x1: 0.739258,
    y1: 20.0011,
    x2: 40.7415,
    y2: 20.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1243_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.740234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.36dd2920d23be6cfce4b0566ddf50b81.svg";
export { ForwardRef as ReactComponent };